import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import Formatters from "../../shared/utils/Formatters";
import { has } from "lodash";
import { segmentEventTracker } from '../../../utils/SegmentEventTracker';
import { TrackEventName } from '../../shared/constants/SegmentEvents';


class LoanPlanOverviewTradeDocumentsTable extends Component {
  onClick = (tradeDoc) => {
    segmentEventTracker.trackEvent(TrackEventName.TRADE_DOC_VIEW_DETAILS_CLICKED);
    this.props.dispatch(push(this.tradeDocLink(tradeDoc)));
  }

  tradeDocTypeTitleized = (tradeDoc) => {
    if (has(tradeDoc, "purchase_order_number")) return "Purchase Order";

    return "Invoice";
  }

  tradeDocName = (tradeDoc, index) => {
    return this.props.buyer_name ||
      `${this.tradeDocTypeTitleized(tradeDoc)} #${index + 1}`;
  }

  tradeDocLink = (tradeDoc) => {
    if (has(tradeDoc, "purchase_order_number")) return `/purchase_orders/${tradeDoc.id}`

    return `/invoices/${tradeDoc.id}`;
  }

  renderTradeDocRows = () => {
    return this.props.trade_documents.map((td, index) => {
      const { id, amount } = td;

      return(
        <Fragment>
          <div className="ds-dataSet _parallelData" key={id}>
            <div className="ds-data">
              <small className="dataName">Buyer</small>
              <p className="data">{this.tradeDocName(td, index)}</p>
            </div>
            <div className="ds-data">
              <small className="dataName">Amount</small>
              <p className="data"><span className="sub">₱</span> {Formatters.amount({ amount: amount })}</p>
            </div>
          </div>
          <a data-testid="trade-doc-view-details-btn" onClick={() => { this.onClick(td) }} className="ds-btn --small -secondary">View Details</a>
        </Fragment>
      )
    })
  }

  render() {
    if(!this.props.trade_documents) return <div />;

    return (
      <div className="ds-card"> 
        <section className="cardTitle">Approved Trade Document</section>
        <section className="cardSection">
          {this.renderTradeDocRows()}
        </section>
      </div>
    )
  }

}

export default connect()(LoanPlanOverviewTradeDocumentsTable);



// WEBPACK FOOTER //
// ./src/features/loans/containers/LoanPlanOverviewTradeDocumentsTable.js